import React, { useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { ArrowLeftRight, Trash } from 'react-bootstrap-icons';
import './Node.css';

const IsInSegmentNode = ({ data, id, outputEdges }) => {
  const [isHovered, setIsHovered] = useState(false);

  // Define color scheme
  const colors = {
    container: 'custom-node node-rounded-lg node-border-blue',
    header: 'node-header node-bg-blue-gradient node-border-blue-bottom',
    text: 'node-text-blue',
    handle: 'node-handle-small node-handle-blue'
  };

  return (
    <div 
      className={`${colors.container} node-hover-lift`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button */}
      <div 
        className={`delete-btn delete-btn.top-center ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className="icon-trash" />
      </div>

      {/* Header section */}
      <div className={colors.header}>
        <div className="node-header-content">
          <ArrowLeftRight className='node-icon' style={{ color: '#3599ab' }}/>
          <span className={`node-title ${colors.text}`}>Segment</span>
        </div>
      </div>

      {/* Handles */}
      
      <Handle
        type="source"
        position={Position.Right}
        className={colors.handle}
      />
    </div>
  );
};

export default IsInSegmentNode;
